import { getStrWithoutSpaces } from 'legacy/lut/components/widgets/public/partner360/helpers/getStrWithoutSpaces'

import { FINANCIAL_COCKPIT_NAMESPACE } from '../configs/translations'

/* The cockpit names an offering with its own key rather than the partner pages' `jbp-partner-type-*`,
   so a reseller's `Personal Systems` and a distributor's `PC` can read as one programme. */
export const getOfferingTitleKey = (programType: string) =>
  `${FINANCIAL_COCKPIT_NAMESPACE}-program-types-title-${getStrWithoutSpaces(programType)}`
